/**
 * AYUNEL 2点セット / まとめ買い —— blocks/ayunel-pdp-bundle.liquid 的行为层(新房 Horizon 4.1.4 起;4.2 维护源码在
 * 08-themes/horizon42-20261003/overlay/)。2026-09-12;2026-10-06 加 まとめ買い 形态。
 *
 * 两种形态是同一个 Custom Element <ayunel-pdp-bundle>,data-ayn-mode="matome" 时走多选分支
 * (标记在 snippets/ayunel-pdp-matome.liquid)。分支只在「这次选了哪几件」(#picks)、「怎么跟上方选择器」(#followPage)
 * 和「价格行 / 按钮文案怎么显示」三处;加购、价格公式、成败核对、锁、埋点是同一份代码,不许复制出第二份。
 *
 * 以 <script type="module"> 引入(与购物车页 ayunel-gift-sync-v2.js 同姿势):
 * 要 import 4.1.4 的标准事件,普通 {% javascript %} 里写不了静态 import。
 * 算价 / 合并 / 跟随 / 加购核对写成导出的纯函数,守卫在 node 里直接跑真代码
 * (tests/test_theme_pdp_bundle.py、tests/test_theme_horizon42_pdp_matome.py)。
 *
 * 死约(每条都对应一个真实踩过 / 审出的坑):
 * - 价格 = Shopify 结算同算法:先把同一变体合并成一行,每行折扣额 = floor(行金额 × 折扣率 / 100),显示价 = Σ行金额 − Σ折扣额
 *   (offOf / priceOf)。Liquid 端同一公式。档位按所选总件数:2 件 discount_percent、3 件以上 discount_percent_3、1 件不打折。
 *   live 用「合计 × (100 − pct)% 四舍五入」,两组页面比结算便宜 ¥1(2026-09-12 真实订单 174 条分摊证实)。
 * - 价格行文案全部由 Liquid 渲染好(带 {n} 占位的句式放 data-*),这里只换数字、切 hidden;本文件不出现任何对客价格文案。
 *   2026-10-05 GMC 复审 C1(智鹏改选 A):保留划线(所选现价合计,真实价格、非虚构原价),撤积分条件价;
 *   恢复积分价须智鹏 / 小张本人重新拍板。
 * - 加购后只发 4.1.4 标准事件 CartLinesUpdateEvent(页头数字 cart-icon / 读屏 header-actions / 同页 product-form 都只认它),
 *   detail.items 必须是 /cart.js 的**整车** items(cart-icon 按它过滤 _ayn_gift 赠品求和)。
 *   3.x 的 cart:update / cart:added / variant:change、window.publish 在新房里没有任何监听者,一个都不发。
 * - 所选几件永远一次请求加(items[]):拆成多个并发请求,还没有购物车的新客会各建一个车、静默掉单。
 *   同一变体合并成一行、数量相加(当前款与色違い选成同色同码 = 数量 2);事件 lines、POST items、成败核对用同一份合并结果。
 * - 成败以购物车实际变化为准:先等别的组件在途的加购结束、**再**读整车当基线(先读后等,基线会漏掉别人刚加的那件)。
 *   **基线读不到(重试一次仍失败)就不发加购**:没有基线,回包一丢就分不清加没加上。
 *   服务器明确回了成功就算成功(不被读车差推翻,二轮复审 A2);回包丢了 / 超时 / 报错才看读车差,
 *   按「每个变体的期望增量」逐个核对(verifyLines):全到 = 成功;只到一部分(超库存时 Shopify 可能只加可用数量)=
 *   如实提示「一部の商品のみ」+ 购物车入口,并把按钮停住到客人改选择为止 —— 绝不让客人整批重按、把已进车的再加一遍。
 *   旧版 verifyAdded 只认两个不同 ID 各 +1,两件同变体时只 +1 也会判成功(Codex 2026-10-06 方案复审第 4 条),已改为包装 verifyLines。
 *   所有请求 10 秒超时(可控计时器实现,测试里能模拟卡住;也不依赖 Safari 16 才有的 AbortSignal.timeout)。
 * - 加购成功、之后读车失败:事件带 cartRefreshFailed(加购弹窗 ayunel-cart-drawer.js 见到就不弹 —— 旧弹窗里是加购前的车,
 *   会诱导客人再加一次),按钮下给「カートを確認する」入口。与原生 product-form 同口径同文案(2026-10-03 4.2 迁移)。
 * - 交易锁跟着请求走,不跟 DOM 挂载走:请求途中元素被移出再挂回(主题编辑器重渲染),锁不解、旧请求照常收尾;
 *   请求在途期间另有模块级标记,换成新实例也不能再发(二轮复审)。
 * - 新客(还没有 cart cookie)时,别的组件(上方「カートに追加」)的加购还在途 → 先等它结束再发:
 *   两个请求同时建车,Shopify 会各建一个、后到的 cookie 覆盖前者,一方商品静默消失(二轮真机实测 3/3)。
 *   反过来(本块先发、别的按钮后点)从这边堵不住,属平台层并发,登记在 anatomy。
 * - 点下后锁到「カートに追加しました」提示结束(2.4 秒)再放开:提示还在就能再点 = 再加一整套(live 就是锁 2.4 秒)。
 *   锁的期间按钮保持黑色、不设 disabled(禁用灰 = 缺货的样子);请求在途时购物袋图标换成白色小圈
 *   (智鹏 2026-09-12 拍板,设计手册 §K.2-63 选 ①),结果回来换成对勾 / 复原。
 * - 买不了(任一所选件无货)→ 按手册 §C1.4:按钮文案「在庫切れ」+ disabled 与 aria-disabled 双写。
 *   まとめ買い 一件都没勾 → 按钮禁用、文案换成「上の商品から選んでください」(brand-crm 终审 2026-10-06)。
 * - 失败提示放在按钮下方独立一行(role=alert),下次换选项或再点才收起;不在黑按钮里闪 3 秒就没。
 * - 埋点只走 window.aynTrack(统一出口:自测带 ayn_qa、主题编辑器里不存在 → 自然不发),找不到就不发、不轮询等待。
 *   事件名沿用 ayn_bundle_*;2026-10-06 起每条带 bundle_mode(pair / matome)区分新旧形态,加购带 items_count。
 *   金额 value = 所选折前合计 ÷ 100(价格单位是「分」)。🔴 绝不发标准 add_to_cart(Shopify 原生已在发,再发 = 双计数)。
 *   曝光:まとめ買い 观察「标题 + 瓷砖」那一段([data-ayn-view-anchor],高度固定)—— 整块随勾选变高,
 *   高过两倍视口时 50% 阈值永远到不了(Codex 方案复审第 8 条);2点セット 仍观察整块。
 * - 订单标记 _ayn_bundle 是**购物车属性**(不是商品行属性),只经 assets/ayunel-track.js 的 aynMarkBundle 写:
 *   每个「非当前款」的所选件各记一组「当前款>该款@颜色」(色違い = 当前款>当前款@颜色)。这里绝不自己请求 /cart/update.js。
 * - 2点セット 主商品槽跟随页面上方原生选择器(shopify:product:select),**只同步这次真正变了的那一项**:
 *   两项一起覆盖会把客人在套装里改好的尺码被一次「点色块看图」悄悄冲回 S(2026-09-12 独立审查实测)。
 *   まとめ買い 的当前款没有自己的下拉,完全跟上方;其余各行**客人没动过的**颜色按 Liquid 给的对照表、尺码跟上方,
 *   客人动过的那一项不再被覆盖(followRow)。只认本页主商品的事件(同页推荐卡也会派这个事件)。
 * - 挂载时先读一次上方选择器的当前选择:慢网下原生选择器比本模块早就绪(Fast 3G 实测晚 2.7 秒)。
 * - 换颜色不改客人已选的尺码:该尺码无货就标「（在庫切れ）」、按钮「在庫切れ」,不悄悄跳回 S;
 *   选中项无货的那个下拉框文字变淡 + 删除线,窄框里看不见后缀也能认出是哪一个。
 * - 浏览器「返回」时会把下拉恢复成上次的选择且不发 change:load / pageshow 时重算一次(select 另有 autocomplete=off)。
 * - Custom Element:morph / 主题编辑器重挂时自动解绑再绑;SSR JSON 每次用时现读,不在挂载时缓存。
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const TAG = 'ayunel-pdp-bundle';
const SOURCE = 'ayunel-pdp-bundle';
const MS_ADDED = 2400;
const MS_TIMEOUT = 10000;

// 对客提示(非价格文案)。confirm 与原生 product-form 的「加购成功但读不到车」同一句(2026-10-03);
// partial 是 2026-10-06 新句,brand-crm 终审定稿(2026-10-06)。
const MSG_CONFIRM = '商品はカートに追加されました。カートで内容をご確認ください。';
const MSG_PARTIAL =
  '在庫が不足していたため、一部の商品のみカートに追加しました。割引は点数に応じてカートで計算されますので、内容をご確認ください。';
// unknown 是 Codex 2026-10-06 复审后新增的句子,brand-crm 终审定稿(2026-10-06)。末句「再読み込み…もう一度」成立的前提:
// 停住按钮的锁只在内存里,刷新页面即恢复可点(DEV 真浏览器实测 2026-10-06);以后若把锁存进 storage,这句要一起改。
const MSG_UNKNOWN =
  '通信の状況により、カートへの追加を確認できませんでした。お手数ですが、カートで内容をご確認ください。追加されていない場合は、ページを再読み込みしてもう一度お試しください。';
const MSG_CART_LINK = 'カートを確認する';

/** 分 → 「¥10,380」(与 Liquid money 过滤器同形:店铺格式 ¥{{amount_no_decimals}}) */
const yen = (cents) => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');

/** 一行的折扣额(分):整円 × pct / 100 往下取整。全程整数运算,不经浮点。 */
export const offOf = (cents, pct) => {
  const t = Math.round(cents / 100) * pct;
  return ((t - (t % 100)) / 100) * 100;
};

/** 件数 → 折扣率:3 件以上 three、2 件 two、其余 0(1 件不打折) */
export const tierPct = (n, tiers) => (n >= 3 ? tiers.three : n === 2 ? tiers.two : 0);

/** 同一变体合并成一行、数量相加(保持首次出现的顺序):[{id, price, quantity?}] → [{id, price, quantity}] */
export const mergeLines = (picks) => {
  const out = [];
  const at = new Map();
  for (const p of picks) {
    const key = String(p.id);
    const q = p.quantity || 1;
    if (at.has(key)) out[at.get(key)].quantity += q;
    else {
      at.set(key, out.length);
      out.push({ ...p, quantity: q });
    }
  }
  return out;
};

/** 价格行(合并后的行):划线 sub = Σ行金额;显示 net = sub − Σ每行 floor 折扣额;n = 总件数,pct = 该件数的档位 */
export const priceOf = (lines, tiers) => {
  const n = lines.reduce((s, l) => s + l.quantity, 0);
  const pct = tierPct(n, tiers);
  let sub = 0;
  let off = 0;
  for (const l of lines) {
    const amount = l.price * l.quantity;
    sub += amount;
    off += offOf(amount, pct);
  }
  return { n, pct, sub, net: sub - off };
};

/** 2点セット 价格行(两件不同商品,与 Liquid subtotal / net_total 同公式) */
export const priceView = (mainCents, pairedCents, pct) => {
  const v = priceOf(
    [
      { price: mainCents, quantity: 1 },
      { price: pairedCents, quantity: 1 },
    ],
    { two: pct, three: pct }
  );
  return { sub: v.sub, net: v.net };
};

/** 上方选择器这次真正变了哪几项:返回 [[下标, 新值], …](下标 0 = 颜色,1 = 尺码) */
export const changedPicks = (prev, cur, names) => {
  const out = [];
  names.forEach((name, i) => {
    if (cur[name] != null && cur[name] !== prev[name]) out.push([i, cur[name]]);
  });
  return out;
};

/**
 * まとめ買い 一行跟随上方选择:客人动过的那一项保留;没动过的颜色按对照表(本款颜色 → 该行默认色)、尺码跟上方
 * (该行没有这个尺码就保留原值)。row = {color, size, touchedColor, touchedSize, defaults, sizes};page = {color, size}
 */
export const followRow = (row, page) => ({
  color: row.touchedColor ? row.color : (row.defaults && row.defaults[page.color]) || row.color,
  size: row.touchedSize || !(row.sizes || []).includes(page.size) ? row.size : page.size,
});

/** 购物车非赠品件数(与 cart-icon / header-actions 的 AYUNEL OVERRIDE 同口径) */
const nongift = (items) =>
  (items || []).reduce(
    (sum, it) => (it.properties && it.properties._ayn_gift === '1' ? sum : sum + (it.quantity || 0)),
    0
  );

const qtyOf = (items, id) =>
  (items || []).reduce((s, it) => (Number(it.variant_id ?? it.id) === Number(id) ? s + (it.quantity || 0) : s), 0);

/**
 * 加购前后两次整车对比,逐个变体看增量够不够(expected 必须是 mergeLines 合并过的行,同一变体只出现一次)。
 * → null(任一边没有车)| {state: 'full' | 'partial' | 'none', got: [{id, want, delta}]}
 */
export const verifyLines = (beforeItems, afterItems, expected) => {
  if (!beforeItems || !afterItems) return null;
  const got = expected.map((l) => ({
    id: l.id,
    want: l.quantity,
    delta: qtyOf(afterItems, l.id) - qtyOf(beforeItems, l.id),
  }));
  const full = got.every((g) => g.delta >= g.want);
  const some = got.some((g) => g.delta > 0);
  return { state: full ? 'full' : some ? 'partial' : 'none', got };
};

/** 两件的旧接口(守卫与收藏页说明仍引用):同一变体时要 +2 才算 */
export const verifyAdded = (beforeItems, afterItems, aId, bId) => {
  const r = verifyLines(beforeItems, afterItems, mergeLines([{ id: aId }, { id: bId }]));
  return r ? r.state === 'full' : null;
};

/**
 * 判定这次加购的结果:posted = 服务器明确回了成功;check = verifyLines 的结果(加购后读不到车 = null)。
 * ok 成功 / confirm 成功但读不到车(让客人去购物车确认、不弹旧弹窗)/ partial 只进了一部分 / fail 核过车、确实没进 /
 * unknown 没明确成功、又读不到车 = 加没加上都不知道:不许当「没进」放客人重按 —— 回包丢、422 超库存(可能已加一部分)、
 * 500(服务端可能已写)都算(Codex 2026-10-06 复审 + 补审:重按会把已进车的再加一份)
 */
export const outcomeOf = (posted, check) => {
  if (posted) return check ? 'ok' : 'confirm';
  if (!check) return 'unknown';
  if (check.state === 'none') return 'fail';
  return check.state === 'full' ? 'ok' : 'partial';
};

const routes = () => {
  const r = (window.Theme && window.Theme.routes) || {};
  const page = r.cart_url || '/cart';
  return { add: r.cart_add_url || '/cart/add.js', cart: page + '.js', page };
};

/** 有没有购物车 cookie(与 ayunel-track 同一判据:非空 token) */
const hasCartCookie = () => {
  try {
    return /(^|;\s*)cart=[A-Za-z0-9_-]{20,}/.test(document.cookie);
  } catch {
    return false;
  }
};

/** 页面上别的组件(上方原生「カートに追加」等)在途的加购:新客时要等它们建好车再发 */
const othersInFlight = new Set();
document.addEventListener('shopify:cart:lines-update', (event) => {
  if (event?.detail?.source === SOURCE || event?.action !== 'add' || !event.promise) return;
  const p = Promise.resolve(event.promise).catch(() => {});
  othersInFlight.add(p);
  p.finally(() => othersInFlight.delete(p));
});
const waitOthersIfNoCart = () => {
  if (hasCartCookie() || othersInFlight.size === 0) return Promise.resolve();
  return Promise.race([Promise.allSettled([...othersInFlight]), new Promise((r) => setTimeout(r, MS_TIMEOUT))]);
};

/** 本模块的加购请求在途(模块级:元素换成新实例也挡得住) */
let requestInFlight = false;

/** 10 秒超时的 signal(用 setTimeout 实现:可测、且不依赖 AbortSignal.timeout) */
const timeoutSignal = () => {
  const c = new AbortController();
  setTimeout(() => c.abort(), MS_TIMEOUT);
  return c.signal;
};

const readCart = async (url) => {
  const res = await fetch(url, { cache: 'no-store', headers: { Accept: 'application/json' }, signal: timeoutSignal() });
  if (!res.ok) throw new Error('cart ' + res.status);
  return res.json();
};

/** 读整车,失败重试一次;两次都失败 → null */
const readCartTwice = async (url) => {
  for (let i = 0; i < 2; i++) {
    try {
      return await readCart(url);
    } catch {}
  }
  return null;
};

class AyunelPdpBundle extends HTMLElement {
  #abort = null;
  #io = null;
  #timer = 0;
  #busy = false;
  #labelBase = '';
  #pagePrev = null;
  /** 只进了一部分 / 结果不明之后停住按钮,直到客人改了选择(防整批重按;两种形态都适用) */
  #partialHold = false;

  connectedCallback() {
    if (this.#abort) return;
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    const label = this.querySelector('[data-ayn-cta-label]');
    this.#labelBase = this.dataset.aynMsgBuy || (label ? label.textContent : '');

    this.addEventListener('change', this.#onChange, { signal });
    this.addEventListener('click', this.#onClick, { signal });
    const scope = this.closest('.shopify-section') || document;
    scope.addEventListener('shopify:product:select', this.#onPageSelect, { signal });
    // 浏览器「返回」恢复表单是在 load 之前、且不发 change → load / pageshow 先重读上方选择器、再算一次
    // (只 refresh 会沿用旧的上方选择,加购进去的是恢复前的颜色尺码 —— Codex 2026-10-06 复审)
    // 只有 まとめ買い 重读:2点セット 的主商品槽有自己的下拉、客人可能在里面改过,重读会把它冲掉(Codex 补审)
    const restore = () => {
      if (this.#matome) this.#syncFromPagePicker();
      this.#refresh();
    };
    window.addEventListener('pageshow', restore, { signal });
    if (document.readyState !== 'complete') window.addEventListener('load', restore, { signal, once: true });

    if ('IntersectionObserver' in window) {
      this.#io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.#track('ayn_bundle_view');
            this.#io?.disconnect();
            this.#io = null;
          }
        },
        { threshold: 0.5 }
      );
      this.#io.observe(this.querySelector('[data-ayn-view-anchor]') || this);
    }

    this.#refresh();
    this.#syncFromPagePicker();
  }

  disconnectedCallback() {
    // 只拆监听与观察器;#busy 与成功提示的计时器不动 —— 请求途中被移出再挂回时,锁不能提前解开(二轮复审)
    this.#abort?.abort();
    this.#abort = null;
    this.#io?.disconnect();
    this.#io = null;
  }

  get #matome() {
    return this.dataset.aynMode === 'matome';
  }

  get #data() {
    try {
      return JSON.parse(this.querySelector('script[data-ayn-bundle-data]')?.textContent || 'null');
    } catch {
      return null;
    }
  }

  #tiers(data) {
    const two = Number(data?.pct) || 0;
    return { two, three: this.#matome ? Number(data?.pct3) || 0 : two };
  }

  #select(slot, opt) {
    return this.querySelector(`select[data-ayn-slot="${slot}"][data-ayn-opt="${opt}"]`);
  }

  /** 槽位 → 变体表:2点セット 是 main / paired;まとめ買い 的各行是 r0、r1 …(对应 data.rows 下标) */
  #variantsOf(data, slot) {
    const row = /^r(\d+)$/.exec(slot);
    return (row ? data?.rows?.[Number(row[1])]?.variants : data?.[slot]?.variants) || [];
  }

  #variantOf(data, slot) {
    const color = this.#select(slot, 'color')?.value;
    const size = this.#select(slot, 'size')?.value;
    return this.#variantsOf(data, slot).find((v) => v.option1 === color && v.option2 === size) || null;
  }

  #slots(data) {
    return this.#matome ? (data?.rows || []).map((_, i) => 'r' + i) : ['main', 'paired'];
  }

  #tile(i) {
    return this.querySelector(`[data-ayn-row="${i}"]`);
  }

  /** 上方选择器的当前选择 {选项名: 值};还没收到过就用 SSR 的初始值 */
  #pageState(data) {
    const names = data.main?.options || [];
    if (!this.#pagePrev) this.#pagePrev = { [names[0]]: data.page_initial?.[0], [names[1]]: data.page_initial?.[1] };
    return this.#pagePrev;
  }

  /** 这次选中的几件,按顺序:[{slot, pid, handle, v}](v 找不到 = null)。まとめ買い 第一件永远是当前款(跟上方) */
  #picks(data) {
    if (!this.#matome) {
      return [
        { slot: 'main', pid: data.main?.id, handle: this.dataset.aynMain, v: this.#variantOf(data, 'main') },
        { slot: 'paired', pid: data.paired?.id, handle: this.dataset.aynPaired, v: this.#variantOf(data, 'paired') },
      ];
    }
    const names = data.main?.options || [];
    const page = this.#pageState(data);
    const cur = (data.main?.variants || []).find((v) => v.option1 === page[names[0]] && v.option2 === page[names[1]]);
    const out = [{ slot: 'main', pid: data.main?.id, handle: this.dataset.aynMain, v: cur || null }];
    (data.rows || []).forEach((row, i) => {
      if (this.#tile(i)?.getAttribute('aria-pressed') === 'true') {
        out.push({ slot: 'r' + i, pid: row.pid, handle: row.handle, v: this.#variantOf(data, 'r' + i) });
      }
    });
    return out;
  }

  #track(name, params) {
    const payload = Object.assign(
      {
        bundle_id: this.dataset.aynBundle,
        bundle_mode: this.#matome ? 'matome' : 'pair',
        main_product: this.dataset.aynMain,
        paired_product: this.dataset.aynPaired,
      },
      params || {}
    );
    if (typeof window.aynTrack !== 'function') return;
    try {
      window.aynTrack(name, payload);
    } catch {}
  }

  /** 下拉里的「（在庫切れ）」标注:颜色看「这个颜色还有没有任何可售尺码」,尺码看「当前颜色下这一码」 */
  #syncOptions(data, slot) {
    const list = this.#variantsOf(data, slot);
    const sold = this.dataset.aynSold || '';
    const colorSel = this.#select(slot, 'color');
    const sizeSel = this.#select(slot, 'size');
    if (!colorSel || !sizeSel) return;

    for (const op of colorSel.options) {
      const base = op.dataset.aynBase ?? op.textContent;
      const any = list.some((v) => v.option1 === op.value && v.available);
      op.textContent = any ? base : base + sold;
    }

    const colorOut = !list.some((v) => v.option1 === colorSel.value && v.available);
    colorSel.toggleAttribute('data-ayn-soldout', colorOut);

    const color = colorSel.value;
    for (const op of sizeSel.options) {
      const base = op.dataset.aynBase ?? op.textContent;
      const hit = list.find((v) => v.option1 === color && v.option2 === op.value);
      const out = !hit || !hit.available;
      // 已选中的那一码也照样标、照样禁选:保留客人的选择让他看见原因,不替他改(live 会悄悄跳回 S)
      op.disabled = out;
      op.textContent = out ? base + sold : base;
    }
    const chosen = list.find((v) => v.option1 === color && v.option2 === sizeSel.value);
    sizeSel.toggleAttribute('data-ayn-soldout', !colorOut && !(chosen && chosen.available));
  }

  /** 同一槽位可能有两张小图(まとめ買い:瓷砖 + 展开行),一起换 */
  #syncThumb(slot, v) {
    const src = v?.featured_image?.src; // SSR 已给 240 宽的地址(与首屏 <img> 同宽)
    for (const img of this.querySelectorAll(`[data-ayn-thumb="${slot}"]`)) {
      if (src) img.src = src;
      else if (img.dataset.aynThumbDefault) img.src = img.dataset.aynThumbDefault;
    }
  }

  /** まとめ買い:瓷砖 / 展开行的单价与瓷砖读屏名跟着所选变体变(同款不同码价格不同时,SSR 初值会过期) */
  #syncUnitPrice(slot, v) {
    if (!v) return;
    for (const el of this.querySelectorAll(`[data-ayn-unit="${slot}"]`)) el.textContent = yen(v.price);
    const tile = this.querySelector(`[data-ayn-row="${slot.slice(1)}"]`);
    if (tile?.dataset.aynAriaBase) tile.setAttribute('aria-label', tile.dataset.aynAriaBase + ' ' + yen(v.price));
  }

  #renderPrice(v) {
    const subEl = this.querySelector('[data-ayn-subtotal]');
    const netEl = this.querySelector('[data-ayn-net]');
    if (subEl) subEl.textContent = yen(v.sub);
    if (netEl) netEl.textContent = yen(v.net);
  }

  /** まとめ買い:只换件数、切 hidden(句式在 Liquid)。1 件:不显示划线 / 箭头 / 注记,行区收起 */
  #renderMatome(n) {
    const many = n >= 2;
    this.querySelector('[data-ayn-subtotal]')?.toggleAttribute('hidden', !many);
    this.querySelector('[data-ayn-arrow]')?.toggleAttribute('hidden', !many);
    const terms = this.querySelector('[data-ayn-terms]');
    if (terms) {
      terms.hidden = !many;
      if (many) terms.textContent = n === 2 ? terms.dataset.aynTermsTwo : String(terms.dataset.aynTermsMany).replace('{n}', n);
    }
    this.querySelector('[data-ayn-nudge="1"]')?.toggleAttribute('hidden', n !== 1);
    this.querySelector('[data-ayn-nudge="2"]')?.toggleAttribute('hidden', n !== 2);
    const lines = this.querySelector('[data-ayn-lines]');
    if (lines) lines.hidden = !many;
  }

  #refresh() {
    const data = this.#data;
    if (!data) return;
    for (const slot of this.#slots(data)) {
      this.#syncOptions(data, slot);
      const v = this.#variantOf(data, slot);
      this.#syncThumb(slot, v);
      if (this.#matome) this.#syncUnitPrice(slot, v);
    }

    const picks = this.#picks(data);
    const complete = picks.every((p) => p.v);
    if (complete) {
      this.#renderPrice(priceOf(mergeLines(picks.map((p) => ({ id: p.v.id, price: p.v.price }))), this.#tiers(data)));
    }
    if (this.#matome) this.#renderMatome(picks.length);
    if (this.#busy) return;

    const ready = picks.length >= 2 && complete && picks.every((p) => p.v.available);
    if (!this.#matome) {
      this.#setBuyable(ready && !this.#partialHold, ready ? this.#labelBase : this.dataset.aynMsgSold || this.#labelBase);
      return;
    }
    let label = String(this.dataset.aynMsgBuyN || this.#labelBase).replace('{n}', picks.length);
    if (picks.length < 2) label = this.dataset.aynMsgEmpty || label;
    else if (!ready) label = this.dataset.aynMsgSold || label;
    this.#setBuyable(ready && !this.#partialHold, label);
  }

  /** 买得了 / 买不了(手册 §C1.4:「在庫切れ」+ disabled 与 aria-disabled 双写) */
  #setBuyable(ok, label = ok ? this.#labelBase : this.dataset.aynMsgSold || this.#labelBase) {
    const cta = this.querySelector('[data-ayn-bundle-cta]');
    const labelEl = this.querySelector('[data-ayn-cta-label]');
    if (!cta) return;
    cta.disabled = !ok;
    if (ok) cta.removeAttribute('aria-disabled');
    else cta.setAttribute('aria-disabled', 'true');
    if (labelEl) labelEl.textContent = label;
    this.#icon('bag');
  }

  /** 按钮左侧图标:bag(平时)/ spinner(请求在途)/ check(成功)。svg 没有 .hidden 属性,一律改 hidden 这个 attribute */
  #icon(which) {
    this.querySelector('[data-ayn-icon-bag]')?.toggleAttribute('hidden', which !== 'bag');
    this.querySelector('[data-ayn-icon-spinner]')?.toggleAttribute('hidden', which !== 'spinner');
    this.querySelector('[data-ayn-icon-check]')?.toggleAttribute('hidden', which !== 'check');
  }

  #showError(on) {
    const err = this.querySelector('[data-ayn-error]');
    if (err) err.hidden = !on;
  }

  /**
   * 按钮下的「去购物车确认」提示:confirm(加购成功但读不到车)/ partial(只进了一部分)/ null(收起)。
   * 由这里生成而不写进 Liquid:2点セット 的标记要与改前逐字节一致。
   */
  #notice(kind) {
    this.querySelector('[data-ayn-notice]')?.remove();
    if (!kind) return;
    const p = document.createElement('p');
    p.className = kind === 'confirm' ? 'ayunel-bundle__note' : 'ayunel-bundle__error';
    p.setAttribute('role', 'alert');
    p.setAttribute('data-ayn-notice', kind);
    p.textContent = ({ partial: MSG_PARTIAL, unknown: MSG_UNKNOWN }[kind] || MSG_CONFIRM) + ' ';
    const a = document.createElement('a');
    a.href = routes().page;
    a.textContent = MSG_CART_LINK;
    p.append(a);
    const err = this.querySelector('[data-ayn-error]');
    if (err) err.after(p);
    else this.append(p);
  }

  /** 客人改了选择:收起失败 / 确认提示,放开「只进了一部分」的停住 */
  #clearFeedback() {
    this.#showError(false);
    this.#notice(null);
    this.#partialHold = false;
  }

  #onChange = (event) => {
    const sel = event.target.closest('select[data-ayn-opt]');
    if (!sel) return;
    // まとめ買い:客人亲手改过的这一项,之后不再跟上方选择器
    if (this.#matome) sel.setAttribute('data-ayn-touched', '');
    this.#clearFeedback();
    this.#track('ayn_bundle_variant_select', {
      slot: sel.dataset.aynSlot,
      option_name: sel.dataset.aynOpt,
      option_value: sel.value,
    });
    this.#refresh();
  };

  /** まとめ買い:点瓷砖勾选 / 取消,同时展开 / 收起它那一行 */
  #toggleRow(tile) {
    const i = tile.dataset.aynRow;
    const on = tile.getAttribute('aria-pressed') !== 'true';
    tile.setAttribute('aria-pressed', String(on));
    this.querySelector(`[data-ayn-line="r${i}"]`)?.toggleAttribute('hidden', !on);
    this.#clearFeedback();
    const data = this.#data;
    this.#track('ayn_bundle_item_toggle', {
      slot: 'r' + i,
      product_handle: data?.rows?.[Number(i)]?.handle,
      selected: on,
      items_count: data ? this.#picks(data).length : undefined,
    });
    this.#refresh();
  }

  /** まとめ買い:没被客人动过的各行,颜色按对照表、尺码跟上方(followRow) */
  #followRows(data) {
    const names = data.main?.options || [];
    const page = this.#pageState(data);
    const now = { color: page[names[0]], size: page[names[1]] };
    (data.rows || []).forEach((row, i) => {
      const cs = this.#select('r' + i, 'color');
      const ss = this.#select('r' + i, 'size');
      if (!cs || !ss) return;
      const next = followRow(
        {
          color: cs.value,
          size: ss.value,
          touchedColor: cs.hasAttribute('data-ayn-touched'),
          touchedSize: ss.hasAttribute('data-ayn-touched'),
          defaults: row.defaults,
          sizes: Array.from(ss.options).map((o) => o.value),
        },
        now
      );
      if (Array.from(cs.options).some((o) => o.value === next.color)) cs.value = next.color;
      if (Array.from(ss.options).some((o) => o.value === next.size)) ss.value = next.size;
    });
  }

  /** 上方选择器这次的选择 cur({选项名: 值}):2点セット 只同步变了的那一项进主商品槽;まとめ買い 跟当前款 + 未动过的行 */
  #followPage(data, cur) {
    const names = data.main?.options || [];
    const picks = changedPicks(this.#pageState(data), cur, names);
    this.#pagePrev = { ...this.#pagePrev, ...cur };
    if (this.#matome) {
      if (!picks.length) return;
      this.#clearFeedback();
      this.#followRows(data);
      this.#refresh();
      return;
    }
    let changed = false;
    for (const [i, val] of picks) {
      const sel = this.#select('main', i === 0 ? 'color' : 'size');
      if (!sel || sel.value === val || !Array.from(sel.options).some((o) => o.value === val)) continue;
      sel.value = val;
      changed = true;
    }
    if (changed) {
      this.#clearFeedback();
      this.#refresh();
    }
  }

  /** 页面上方原生选择器换了颜色 / 尺码(只认本页主商品;同页推荐卡也会派这个事件) */
  #onPageSelect = (event) => {
    const data = this.#data;
    if (!data) return;
    const pid = String(event?.product?.id ?? '').split('/').pop();
    if (!pid || pid !== String(data.main?.id)) return;
    const cur = {};
    for (const o of event.selectedOptions || []) cur[o.name] = o.value;
    this.#followPage(data, cur);
  };

  /** 挂载时读上方选择器此刻的选择(与原生 variant-picker 的 getAllSelectedOptions 同一取法) */
  #syncFromPagePicker() {
    const data = this.#data;
    if (!data) return;
    const scope = this.closest('.shopify-section') || document;
    const picker = scope.querySelector(`variant-picker[data-product-id="${data.main?.id}"]`);
    if (!picker) return;
    const cur = {};
    for (const sel of picker.querySelectorAll('select')) {
      const o = sel.selectedOptions?.[0];
      if (o?.dataset?.optionName) cur[o.dataset.optionName] = o.value;
    }
    for (const input of picker.querySelectorAll('input[data-option-name]')) {
      if (input.checked) cur[input.dataset.optionName] = input.value;
    }
    if (Object.keys(cur).length) this.#followPage(data, cur);
  }

  #onClick = (event) => {
    const link = event.target.closest('[data-ayn-product-click]');
    if (link) {
      this.#track('ayn_bundle_product_click', { product_handle: link.dataset.aynHandle, slot: link.dataset.aynSlot });
      return;
    }
    const tile = this.#matome ? event.target.closest('[data-ayn-row]') : null;
    if (tile) {
      this.#toggleRow(tile);
      return;
    }
    const cta = event.target.closest('[data-ayn-bundle-cta]');
    if (!cta || cta.disabled || this.#busy || requestInFlight) return;
    this.#add(cta);
  };

  async #add(cta) {
    const data = this.#data;
    // 点下这一刻冻结选择:事件 lines、POST items、成败核对都用这一份合并结果
    const picks = this.#picks(data);
    if (picks.length < 2 || picks.some((p) => !p.v || !p.v.available)) return;
    const lines = mergeLines(picks.map((p) => ({ id: p.v.id, price: p.v.price })));

    // 锁:从点下到成功提示结束。按钮保持黑色(不设 disabled),连点靠 #busy 挡
    this.#busy = true;
    requestInFlight = true;
    clearTimeout(this.#timer);
    this.#clearFeedback();
    cta.setAttribute('aria-busy', 'true');
    this.#icon('spinner');
    const status = this.querySelector('[data-ayn-status]');
    if (status) status.textContent = '';

    const { add, cart } = routes();
    // 新客先等别的组件的加购建好车,再读基线(先读后等,基线会漏掉别人那件)
    await waitOthersIfNoCart();
    const beforeCart = await readCartTwice(cart);
    if (!beforeCart) {
      requestInFlight = false;
      cta.removeAttribute('aria-busy');
      this.#track('ayn_bundle_add_to_cart_failed', { reason: 'cart_unreadable', items_count: picks.length });
      this.#busy = false;
      this.#showError(true);
      this.#refresh();
      return;
    }

    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
        promise: deferred.promise,
        detail: { source: SOURCE },
      })
    );

    let posted = false;
    let reason = '';
    try {
      const res = await fetch(add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines.map((l) => ({ id: l.id, quantity: l.quantity })) }),
        signal: timeoutSignal(),
      });
      const body = await res.json().catch(() => ({}));
      posted = res.ok && !body.status;
      if (!posted) reason = body.description || body.message || 'HTTP ' + res.status;
    } catch (e) {
      reason = (e && e.message) || 'network';
    }

    // 成功失败都拿整车通报:页头数字永远等于车里真实的非赠品件数
    const full = await readCartTwice(cart);
    const outcome = outcomeOf(posted, full ? verifyLines(beforeCart.items, full.items, lines) : null);
    if (full) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(full),
        detail: {
          source: SOURCE,
          sourceId: SOURCE,
          items: full.items,
          itemCount: nongift(full.items),
          didError: outcome !== 'ok',
        },
      });
    } else {
      // 读不到整车:不 reject(否则页头数字不更新),不给 items / itemCount → cart-icon 自己去重读;
      // 加购其实成功时带 cartRefreshFailed,加购弹窗不弹旧车
      deferred.resolve({
        cart: undefined,
        detail: { source: SOURCE, sourceId: SOURCE, didError: outcome !== 'confirm', cartRefreshFailed: outcome === 'confirm' },
      });
    }
    requestInFlight = false;
    cta.removeAttribute('aria-busy');

    if (outcome === 'ok' || outcome === 'confirm') {
      const params = {
        currency: 'JPY',
        value: Math.round(lines.reduce((s, l) => s + l.price * l.quantity, 0) / 100),
        items_count: picks.length,
        main_variant_id: picks[0].v.id,
      };
      if (this.#matome) params.variant_ids = lines.map((l) => l.id + 'x' + l.quantity).join(',');
      else params.paired_variant_id = picks[1].v.id;
      this.#track('ayn_bundle_add_to_cart', params);
      // 订单标记 _ayn_bundle:每个非当前款各一组「当前款>该款@颜色」,只经 assets/ayunel-track.js 的出口写车
      try {
        for (const p of picks.slice(1)) window.aynMarkBundle?.(data.main?.id, p.pid, p.v.option1);
      } catch {
        /* 打标坏了不影响加购 */
      }
      const label = this.querySelector('[data-ayn-cta-label]');
      if (label) label.textContent = this.dataset.aynMsgAdded || '';
      this.#icon('check');
      if (status) status.textContent = this.dataset.aynMsgAdded || '';
      if (outcome === 'confirm') this.#notice('confirm');
      this.#timer = setTimeout(() => {
        this.#busy = false;
        if (status) status.textContent = '';
        this.#refresh();
      }, MS_ADDED);
    } else if (outcome === 'partial' || outcome === 'unknown') {
      this.#track('ayn_bundle_add_to_cart_failed', { reason: outcome, items_count: picks.length });
      this.#busy = false;
      this.#partialHold = true;
      this.#notice(outcome);
      this.#refresh();
    } else {
      this.#track('ayn_bundle_add_to_cart_failed', { reason: reason || 'cart_unchanged', items_count: picks.length });
      this.#busy = false;
      this.#showError(true);
      this.#refresh();
    }
  }
}

if (!customElements.get(TAG)) customElements.define(TAG, AyunelPdpBundle);
